export const themes = {
  default: {
    thDayPicker: {
      container: 'overflow-hidden relative', // The container element
      wrapper: 'outline-none text-center', // The wrapper element, used for keyboard interaction
      interactionDisabled: '', // Added to the container when there's no interaction with the calendar

      navBar: '', // The navigation bar with the arrows to switch between months
      navButtonPrev: '', // Button to switch to the previous month
      navButtonNext: '', // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default', // Added to the navbuttons when disabled with fromMonth/toMonth props

      months: '', // Container of the months table
      month: '', // The month's main table
      caption: 'font-bold mb-5 text-center text-md text-gray-darker', // The caption element, containing the current month's name and year
      weekdays: '', // Table header displaying the weekdays names
      weekdaysRow: 'flex', // Table row displaying the weekdays names
      weekday:
        'font-bold flex-1 flex-1 flex flex-col items-center justify-center h-9 text-base text-gray-medium uppercase', // Cell displaying the weekday name
      body: 'body', // Table's body with the weeks
      week: 'flex', // Table's row for each week
      day:
        'cursor-pointer flex-1 flex flex-col items-center justify-center h-9 outline-none p-1 rounded-none text-base text-center transition-all', // The single day cell

      footer: 'mt-3', // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button', // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline', // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-40 opacity-100 Datepicker-selected', // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium', // Added to the day's cell specified in the "disabledDays" prop
      outside: 'opacity-50', // Added to the day's cell outside the current month
    },
    thDay: 'bg-emerald rounded text-white',
    thDayEnd: 'bg-emerald rtl:rounded-r text-white',
    thDayHovered: 'rtl:rounded-r',
    thDaysHovered: 'bg-overlay-emerald-40',
    thDaysSelected: 'bg-overlay-emerald-40 text-black',
    thDayStart: 'bg-emerald rtl:rounded-l text-white',
  },
};
